import { useDispatch, useSelector } from "react-redux"
import { useEffect, useRef, useState } from "react"
import Button from "../../../../common/Button"
import RemoveDataConfirmationModal from "../../../../common/RemoveDataConfirmationModal"
import classes from './PreoperativeTestsRepeater.module.css'
import { caseQuickUpdate } from "../../../../../lib/fetchApi"
import { notificationActions } from "../../../../../store/notifications"
import { caseActions } from "../../../../../store/case"
import PreoperativeTestsRepeaterItem from "./PreoperativeTestsRepeaterItem"
import { formatDate } from "../../../../../lib/script"

const SAVE_DELAY_MS = 500

export default function PreoperativeTestsRepeater({itemData, apiCase, field}) {

    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const defaultRepeaterItem = {
        id: 1,
        data: {
            name: null,
            requested: null,
            requested_date: null,
            obtained: null,
            obtained_date: null
        }
    }

    // API often returns [] for unchecked/new clearances; [] is truthy so we must treat empty as "no rows yet"
    const [numberOfGroups, setNumberOfGroups] = useState(
        itemData[field]?.length > 0 ? itemData[field] : [defaultRepeaterItem]
    )
    const [removeConfirmId, setRemoveConfirmId] = useState(null)
    const saveTimerRef = useRef(null)
    const saveSeqRef = useRef(0)

    function addRepeaterItemHandler(newIndex) {
        let newItem = {
            id: newIndex,
            data: {
                name: null,
                requested: null,
                requested_date: null,
                obtained: null,
                obtained_date: null
            }
        }
        setNumberOfGroups(prev => [...prev, newItem])
    }

    function requestRemoveRepeaterItem(index) {
        setRemoveConfirmId(index)
    }

    function confirmRemoveRepeaterItem() {
        if (removeConfirmId == null) return
        setNumberOfGroups(prev => prev.filter((item) => item.id != removeConfirmId))
        setRemoveConfirmId(null)
    }

    function addItemDataHandler(value) {
        if (value.data.value && value.identifier.field && value.identifier.repeater_id) {            
            setNumberOfGroups(prev => prev.map(item => {
                if (item.id == value.identifier.repeater_id) {
                    let today = formatDate(new Date())
                    let obj = {
                        id: value.identifier.repeater_id,
                        data: {
                            ...item.data,
                            [value.identifier.field]: value.data.value
                        }
                    }

                    if (value.identifier.isCheckbox) {
                        obj.data[value.identifier.field + '_date'] = today
                    }
                    return obj
                } else {
                    return item
                }
            }))
        }
    }

    useEffect(() => {
        const shouldSave = !itemData?.[field]?.length || (itemData?.[field] && itemData?.[field] != numberOfGroups)
        if (!shouldSave) return

        if (saveTimerRef.current) {
            clearTimeout(saveTimerRef.current)
        }

        const groupsToSave = numberOfGroups
        saveTimerRef.current = setTimeout(async () => {
            const requestSequence = ++saveSeqRef.current
            const staleGuardKey = `${activeCase.case.id}:${apiCase}:${itemData.id}:${field}`

            const response = await caseQuickUpdate(
                userToken,
                activeCase.case.id,
                {
                    type: apiCase,
                    type_id: itemData.id,
                    fields: {
                        [field]: groupsToSave,
                    }
                },
                dispatch,
                null,
                {
                    staleGuardKey,
                    staleGuardSequence: requestSequence,
                }
            )

            if (response?.staleResponse || response?.aborted) {
                return
            }

            if (response && response.errorMessage) {
                dispatch(notificationActions.setError(response))
                return
            }

            dispatch(caseActions.modifyActiveCaseMultiple({
                folder: 'surgeries',
                item: {
                    itemId: itemData.id,
                    fields: [
                        {
                            field: field,
                            value: groupsToSave
                        },
                    ]
                }
            }))
        }, SAVE_DELAY_MS)

        return () => {
            if (saveTimerRef.current) {
                clearTimeout(saveTimerRef.current)
            }
        }
    }, [numberOfGroups])

    return <div>

        {numberOfGroups && numberOfGroups.map((groupRepeater, index) => (
            <div key={index} className={classes.item_wrapper}>
                <>
                    {index == numberOfGroups.length-1 ? <div className={classes.button_wrapper}>
                            <Button click={addRepeaterItemHandler.bind(this, groupRepeater.id+1)} title={'Add new item'} btnStyle={'btn_small'}><i className="ti ti-plus"></i></Button>
                        </div>
                        :
                        <div className={classes.button_wrapper} style={{position: 'relative'}}>
                            <Button click={requestRemoveRepeaterItem.bind(this, groupRepeater.id)} title={'Remove item'} btnStyle={'btn_small'}><i className="ti ti-minus"></i></Button>
                            {removeConfirmId == groupRepeater.id && (
                                <RemoveDataConfirmationModal
                                    closeModal={() => setRemoveConfirmId(null)}
                                    removeData={confirmRemoveRepeaterItem}
                                    message={'Are you sure you want to remove this item?'}
                                />
                            )}
                        </div>
                    }
                </>
                <PreoperativeTestsRepeaterItem id={groupRepeater.id} addItemData={addItemDataHandler} itemData={groupRepeater?.data}/>
                
            </div>
            
        ))}

        
    </div>
}
